import React, { useState } from 'react';
import { Box, Button, Dialog, DialogTitle, DialogContent, DialogActions, Typography } from '@mui/material';
import { Images } from '../../assets/common';
import { useTranslation } from 'react-i18next';
import { useHistory } from "react-router-dom";
import AddPopup from '../AddPopup';

export default function LeftBarUpload() {
  const { t } = useTranslation("common");
  const history = useHistory();
  
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isAddPopupOpen, setIsAddPopupOpen] = useState(false);

  const togglePopup = () => setIsPopupOpen((prev) => !prev);

  const openAddPopup = () => {
    setIsAddPopupOpen(true);
    togglePopup(); // Close the initial dialog when opening AddPopup
  };

  const closeAddPopup = () => setIsAddPopupOpen(false);

  const navigateTo = (path) => {
    togglePopup();
    history.push(path);
  };

  return (
    <Box id="sideBarUpload" sx={{ p: 0 }}>
<Button onClick={togglePopup} sx={{ minWidth: 'auto' }}>
  <svg
    width="24"
    height="24"
    viewBox="0 0 32 32"
    fill="black" // Fill color
    xmlns="http://www.w3.org/2000/svg"
    style={{ stroke: '#FFEE20', strokeWidth: 2.5 }} // Outline color and thickness
  >
    <path
      d="M16 21V11.1036M16 11.1036V11M16 11.1036C15.936 11.1036 15.872 11.128 15.8232 11.1768L12 15M16 11.1036C16.064 11.1036 16.128 11.128 16.1768 11.1768L20 15M30 16C30 23.732 23.732 30 16 30C8.26801 30 2 23.732 2 16C2 8.26801 8.26801 2 16 2C23.732 2 30 8.26801 30 16Z"
      strokeLinecap="round"
    />
  </svg>
</Button>


      <Dialog 
        open={isPopupOpen} 
        onClose={togglePopup} 
        fullWidth 
        maxWidth="sm"
        PaperProps={{
          style: {
            backgroundColor: 'rgba(0, 0, 0, 0.5)', 
            borderRadius: 16,
            padding: '20px',
            backdropFilter: 'blur(15px)',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            boxShadow: '0 4px 30px rgba(0, 0, 0, 0.8)',
            overflow: 'visible',
            backgroundImage: 'none',
          }
        }}
        BackdropProps={{
          style: {
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
            backdropFilter: 'blur(10px)',
          }
        }}
      >
        <DialogTitle sx={{ color: 'white', textAlign: 'center', fontSize: '1.5rem', fontWeight: 'bold' }}>
          {t("Create and Upload to SIKI!")}
        </DialogTitle>
        <DialogContent sx={{ paddingTop: '20px' }}>
          <Box display="flex" flexDirection="column" alignItems="center" gap={3}>
            {/* Playlist Creation Button */}
            <Box
              onClick={openAddPopup} // Open AddPopup for Create Playlist
              sx={{
                width: '100%',
                padding: '16px',
                textAlign: 'center',
                borderRadius: 2,
                marginTop: '10px',
                backgroundColor: 'rgba(10, 10, 10, 0.5)', 
                border: '1px solid rgba(255, 255, 255, 0.2)', 
                color: '#FFD700',
                fontWeight: 'bold',
                cursor: 'pointer',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                position: 'relative',
                '&:hover': {
                  transform: 'scale(1.05)',
                  boxShadow: '0px 4px 20px rgba(255, 215, 0, 0.5)',
                },
              }}
            >
              <Typography variant="h6">{t("Create Playlist")}</Typography>
            </Box>
            {/* Music Upload Button */}
            <Box
              onClick={() => navigateTo('/app/UploadMusic')}
              sx={{
                width: '100%',
                padding: '16px',
                textAlign: 'center',
                borderRadius: 2,
                backgroundColor: 'rgba(10, 10, 10, 0.5)', 
                border: '1px solid rgba(255, 255, 255, 0.2)',
                color: '#FFD700',
                fontWeight: 'bold',
                cursor: 'pointer',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                position: 'relative',
                '&:hover': {
                  transform: 'scale(1.05)',
                  boxShadow: '0px 4px 20px rgba(255, 215, 0, 0.5)',
                },
              }}
            >
              <Typography variant="h6">{t("Upload Music")}</Typography>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center' }}>
          <Button 
            onClick={togglePopup} 
            sx={{ color: '#ccc', fontWeight: 'bold' }}
          >
            {t("Cancel")}
          </Button>
        </DialogActions>
      </Dialog>

      {/* AddPopup for creating playlist */}
      <AddPopup
        open={isAddPopupOpen}
        handleClose={closeAddPopup}
        title={t("Create Playlist")}
        api="playlist"
      />
    </Box>
  );
}
